import { Button, ButtonBaseProps, makeStyles, Modal } from '@material-ui/core'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { OrderContext } from './OrderContext'

type NextButtonProps = ButtonBaseProps & { before?: () => void, increments?: number }

export const FakeNextButton: React.FC<ButtonBaseProps & { text?: string }> = (props) => {
    const { t } = useTranslation()
    return <Button
        {...props}
        size='large'
        variant="contained"
        color="primary"
    >
        {props.text || t('continue')}
    </Button>
}

export const NextButton: React.FC<NextButtonProps> = ({ before, increments = 1, ...props }) => {
    const { activeStep, setActiveStep } = useContext(OrderContext)
    const { t } = useTranslation()

    const handleNextClick = () => {
        if (before) before()
        setActiveStep(activeStep + increments)
        window.scrollTo(0, 0)
    }

    return <Button
        {...props}
        size='large'
        variant="contained"
        color="primary"
        onClick={handleNextClick}
    >
        {t('continue')}
    </Button>
}

export const PreviousButton: React.FC<ButtonBaseProps> = (props) => {
    const { activeStep, setActiveStep } = useContext(OrderContext)
    const { t } = useTranslation()

    const handlePreviousClick = () => {
        setActiveStep(activeStep - 1)
        window.scrollTo(0, 0)
    }

    return <Button
        {...props}
        size='large'
        variant="contained"
        color="secondary"
        onClick={handlePreviousClick}
    >
        {t('previous')}
    </Button>
}

export const ReturnToOrders: React.FC<ButtonBaseProps> = (props) => {
    const { initializeOrder } = useContext(OrderContext)
    const history = useHistory()
    const { t } = useTranslation()

    const handleClick = () => {
        history.push('/')
        initializeOrder()
        window.scrollTo(0, 0)
    }

    return <Button
        {...props}
        variant="contained"
        color='secondary'
        onClick={handleClick}
    >
        {t('return_to_returns_list')}
    </Button >
}

export const useStyles = makeStyles(theme => ({
    divider: {
        margin: '30px 0'
    },
    totalSpan: {
        float: 'right',
        fontSize: '1.5rem',
        marginTop: '1rem',
    },
    totalP: {
        textAlign: 'right',
        display: 'block',
        size: '1.1rem'
    },
    summary: {
        display: 'grid',
        gridTemplateColumns: 'auto 50px 50px'
    },
    paper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 350,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}))

export const CancelButton: React.FC<ButtonBaseProps> = (props) => {
    const { setActiveStep, dispatch, setOrderType } = useContext(OrderContext)
    const [display, setDisplay] = useState(false)
    const history = useHistory()
    const classes = useStyles()
    const { t } = useTranslation()

    const handleContinue = () => {
        history.push('/')
        setActiveStep(0)
        setOrderType('Exchange')
        dispatch({ type: 'CancelOrder' })
        window.scrollTo(0, 0)
    }

    return (
        <>
            <Modal
                open={display}
                onClose={() => setDisplay(false)}
                aria-labelledby='cancel-modal-title'
                aria-describedby='cancel-modal-description'
            >
                <div className={classes.paper}>
                    <p>{t('confirm_order_cancel')}</p>

                    <div style={{ width: '100%', marginTop: 30, display: 'flex', flexDirection: 'column', gap: 15 }}>
                        <Button color='secondary' variant='contained' onClick={() => setDisplay(false)}>
                            {t('no_do_not_cancel_order')}
                        </Button>
                        <Button color='primary' variant='contained' onClick={handleContinue}>
                            {t('yes_cancel_order')}
                        </Button>
                    </div>
                </div>
            </Modal>

            <Button
                {...props}
                size='large'
                variant="contained"
                color='secondary'
                onClick={() => setDisplay(true)}
            >
                {t('cancel')}
            </Button>
        </>
    )
}
